// extracted by mini-css-extract-plugin
module.exports = {"alert":"styles_alert__VmicL","alert-display":"styles_alert-display__3mVb0","success":"styles_success__1NVRA","error":"styles_error__rhuj6"};